module.exports = __webpack_public_path__ + "img/step3-d.43bcf74f.png";